import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GoTopButton',
  setup(__props) {

const instance = getCurrentInstance();
const visible = ref(false);
function onScroll(): void {
  if (typeof window === "undefined") return;
  const top = window.pageYOffset || 0;
  visible.value = top > 20;
}
function goTop(): void {
  instance?.proxy.$vuetify.goTo(0);
}

return { __sfc: true,instance, visible, onScroll, goTop }
}

})